import {
    forBrands,
    getFontWeight,
} from '@core-ui/react-stitch';

const setLineHeightAndColorForGap = theme => ({
    lineHeight: '1.38',
    color: theme.color.g2,
});

const setLineHeightColorForBananaRepublic = theme => ({
    color: theme.color.g1,
    lineHeight: '1.43',
});

const setLineHeightColorforAthleta = theme => ({
    color: theme.color.g1,
    lineHeight: '1.4',
});

const bopisBarToggleStyles = () => ({
    order: '2',
    flex: '0 0 auto',
    marginLeft: '0.25rem',
    marginTop: '0',
});

const bopisBarModalToggleStyles = theme => ({
    ...theme.utilities.unbuttonize,
    ...theme.brandFont,
    ...getFontWeight('regular'),
    borderBottom: `1px solid ${theme.color.b1}`,
    color: theme.color.b1,
    fontSize: '0.75rem',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
});

const bopisBarStoreAvailabilityIndicatorStyles = theme => ({
    ...forBrands(theme, {
        gap: setLineHeightAndColorForGap,
        gapfs: setLineHeightAndColorForGap,
        on: setLineHeightAndColorForGap,
        br: setLineHeightColorForBananaRepublic,
        brfs: setLineHeightColorForBananaRepublic,
        at: setLineHeightColorforAthleta,
    }),
    ...theme.brandFont,
    ...getFontWeight('regular'),
    fontSize: '0.75rem', //12px
    display: 'flex',
    alignItems: 'center',
    marginTop: '0.25rem',
    'svg': {
        marginRight: '0.25rem',
    },
});

const bopisBarStoreDetailsStyles = () => ({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .bopis-bar__store-details--single-option': {
        display: 'flex',
        '& .bopis-bar__label-text': {
            order: '1',
            marginRight: '0.25rem',
        },
        '& .bopis-bar__modal-toggle': {
            maxWidth: '40%',
            paddingTop: '3px',
        },
    },
});

const bopisBarLabelTextStyles = theme => ({
    '& .bopis-bar__label-text': {
        color: theme.color.b1,
        textTransform: 'uppercase',
        marginRight: '0',
        marginLeft: '0.25rem',
        fontSize: '0.875rem', //14px
        '@media (min-width:569px)': {
            whiteSpace: 'pre-line',
        },
    },
});

const setFontWeightForGap = () => ({
    fontWeight: '700',
});

const setFontWeightForBanaRepublic = () => ({
    fontWeight: '600',
});

const bopisBarLabelStyles = theme => ({
    ...theme.brandFont,
    ...forBrands(theme, {
        gap: setFontWeightForGap,
        gapfs: setFontWeightForGap,
        on: setFontWeightForGap,
        br: setFontWeightForBanaRepublic,
        brfs: setFontWeightForBanaRepublic,
        at: setFontWeightForBanaRepublic,
    }),
    letterSpacing: '1px',
    marginLeft: '1px',
    padding: '0.25rem 0',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    cursor: 'default',
    flex: '0 1 auto',
    paddingBottom: '0',
    ...bopisBarLabelTextStyles(theme),
    'svg': {
        marginBottom: '1px',
        '& .location-pin--outline-path': {
            fill: theme.color.b1,
        },
    },
    ...forBrands(theme, {
        gap: () => ({
            textTransform: 'none',
        }),
        hc: () => ({
            letterSpacing: '1px',
        }),
    }),
});

export const bopisBarStyles = (theme, hideBopis) => (
    hideBopis ? {
        display: 'none',
    } : {
        flexWrap: 'nowrap',
        paddingTop: '1rem',
        paddingBottom: '1rem',
        borderBottom: `1px solid ${theme.color.g4}`,
        '@media (min-width:1024px)': {
            paddingTop: '0.875rem',
            width: '14.75rem',
            alignItems: 'center',
            justifyContent: 'space-between',
            margin: '0',
            '& .bopis-bar__modal-toggle': {
                ...forBrands(theme, {
                    at: () => ({
                        marginTop: '0.375rem',
                    }),
                }),
            },
        },
        '& .bopis-bar__details': {
            width: '100%',
        },
        '& .bopis-bar__label': {
            ...bopisBarLabelStyles(theme),
        },
        '& .bopis-bar__modal-toggle': {
            ...bopisBarModalToggleStyles(theme),
        },
        '& .bopis-bar__store-details': {
            ...bopisBarStoreDetailsStyles(),
        },
        '& .bopis-bar__store-availabity-indicator': {
            ...bopisBarStoreAvailabilityIndicatorStyles(theme),
        },
        '& .bopis-bar__toggle': {
            ...bopisBarToggleStyles(),
        },
    });